// localStorage wrappers: every access is guarded (private mode, disabled storage).
import { UserRowSchema, type UserRow } from '@solungo/core/schema';

const LAST_DICTIONARY = 'solungo:last-dictionary';
const USER = 'solungo:user';
const PENDING_TARGET = 'solungo:pending-target';
const PENDING_LOCALE = 'solungo:pending-locale';

function get(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
function set(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    // ignore
  }
}

export const storage = {
  getLastDictionary: () => get(LAST_DICTIONARY),
  setLastDictionary: (id: string | null) => set(LAST_DICTIONARY, id),
  // ?locale= and ?target= from the landing survive the sign-in round trip (docs/project.md §10)
  getPendingTarget: () => get(PENDING_TARGET),
  setPendingTarget: (v: string | null) => set(PENDING_TARGET, v),
  getPendingLocale: () => get(PENDING_LOCALE),
  setPendingLocale: (v: string | null) => set(PENDING_LOCALE, v),
  // The last /me response: offline the app opens with the real user (locale, name) instead of a
  // session probe (docs/project.md §8)
  getUser: (): UserRow | null => {
    const raw = get(USER);
    if (!raw) return null;
    try {
      const parsed = UserRowSchema.safeParse(JSON.parse(raw));
      return parsed.success ? parsed.data : null;
    } catch {
      return null;
    }
  },
  setUser: (user: UserRow | null) => set(USER, user === null ? null : JSON.stringify(user)),
  clearAll: () => {
    set(LAST_DICTIONARY, null);
    set(USER, null);
    set(PENDING_TARGET, null);
    set(PENDING_LOCALE, null);
  },
};
